export default __webpack_public_path__ + "static/media/cubs-group.2d9500cd.jpg";